import { Button, Icon } from '@pwc/pwc-deals-ui';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Overlay, Popover } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import useMobile from '../../../hooks/useMobile';

import AddProjectModal from '../../AddProjectModal';
import authorizationService from '../../../services/security/authorizationService';
import { getFakeClientUser } from '../../../redux/security/loggedInUser/loggedInUserSlice';
import { isDSUrlvalid } from '../../../helpers/projectInitUtil';
import './AddProjectHeaderMenu.scss';
import featureFlags from '../../../helpers/featureFlags';

const AddProjectHeaderMenu = () => {
  const { t } = useTranslation();
  const isFakeClientUser = useSelector(getFakeClientUser);
  const [show, setShow] = useState();
  const [target, setTarget] = useState();
  const [showModal, setShowModal] = useState(false);
  const ref = useRef(null);
  const { pathname } = useLocation();
  const title = 'addProject';
  const isMobile = useMobile();

  const handleClick = (event) => {
    setShow(!show);
    setTarget(event.target);
    if (show === true) {
      setTimeout(() => {
        document.body.click();
      }, 200);
    }
  };

  const handleClose = () => {
    setShow(false);
    setTimeout(() => {
      document.body.click();
    }, 200);
  };

  const handlePopupClick = () => {
    if (featureFlags.isProjectInitiationFromCDEEnabled) {
      window.open(
        `${process.env.REACT_APP_DS_CREATE_URL}projects/new`,
        '_blank',
        'noreferrer'
      );
    } else if (isDSUrlvalid()) {
      setShowModal(true);
    }
  };

  return (
    <>
      <div className="add-project-header-menu" ref={ref}>
        {authorizationService.canCreateProjects() &&
          pathname === '/projects' &&
          !isFakeClientUser && (
            <Button
              className="button-avoid-focus add-icon button-link add-popover-button"
              onClick={handleClick}
            >
              <Icon
                name="add"
                className="fill icon-orange"
                width={isMobile ? 24 : 32}
              />
            </Button>
          )}
        <Overlay
          show={show}
          target={target}
          placement="bottom"
          rootClose
          onHide={() => {
            setShow(!show);
          }}
          container={ref.current}
          popperConfig={{
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, 12],
                },
              },
            ],
          }}
        >
          <Popover
            id="popover-add-project"
            ref={ref}
            className="header-add-popover"
          >
            <Popover.Content className="popup-user">
              <div
                className="dropdown-item"
                onClick={handlePopupClick}
                role="presentation"
              >
                <Icon
                  name="folder"
                  width={24}
                  className="outline icon-orange-theme"
                />
                {t(title)}
              </div>
            </Popover.Content>
          </Popover>
        </Overlay>

        <AddProjectModal showModal={showModal} handleClose={setShowModal} />
      </div>
      {show && (
        <div
          className="add-header-popover-overlay"
          onClick={handleClose}
          data-testid="add-header-popover-overlay"
          role="presentation"
        />
      )}
    </>
  );
};

export default AddProjectHeaderMenu;
